import { AlertTriangle, LoaderCircle, Sprout } from "lucide-react";

export function PageLoader({ label = "ခဏစောင့်ပါ…" }: { label?: string }) {
  return <div className="state-card" role="status"><LoaderCircle className="spin" /><b>{label}</b></div>;
}

export function ErrorState({ message, retry }: { message: string; retry?: () => void }) {
  return <div className="state-card error" role="alert"><AlertTriangle /><b>အဆင်မပြေမှုတစ်ခု ဖြစ်ပေါ်နေပါသည်</b><p>{message}</p>{retry && <button className="btn secondary" onClick={retry}>ထပ်မံကြိုးစားမည်</button>}</div>;
}

export function EmptyState({ title, detail, action }: { title: string; detail: string; action?: React.ReactNode }) {
  return <div className="state-card"><span className="empty-illustration"><Sprout /></span><b>{title}</b><p>{detail}</p>{action}</div>;
}
